import React from 'react';
import { motion } from 'framer-motion';
const tomos = [{
  emoji: '🍞',
  title: 'Tomo 1 — El Salado de Mostrador',
  subtitle: 'Facturas, Bizcochitos, Pan Casero y Prepizzas',
  desc: 'El producto de mayor rotación diaria en Argentina. Técnica de hojaldrado sin sobadora, bizcochitos que se quiebran solos y prepizzas con 533% de margen.'
}, {
  emoji: '🧀',
  title: 'Tomo 2 — El Mundo del Chipá y el Queso',
  subtitle: 'Chipá Correntino, Chipá Relleno, Pan de Queso y Sistema Freezado',
  desc: 'El producto sin gluten de mayor margen del pack. El sistema de chipá crudo congelado que te da stock para 90 días produciendo una sola vez.'
}, {
  emoji: '🍪',
  title: 'Tomo 3 — El Reino del Alfajor',
  subtitle: 'Maicena, Marplatense, Conitos y Ediciones Gourmet',
  desc: 'El producto más amado de Argentina. La proporción exacta 70/30 que hace que nunca más se te rompa un alfajor. La cobertura de chocolate económica con acabado profesional.'
}, {
  emoji: '🫖',
  title: 'Tomo 4 — La Hora del Mate',
  subtitle: 'Pastafrolas, Budines Húmedos y Muffins de Kiosco',
  desc: 'El mercado más constante del año. El secreto del budín que dura 5 días húmedo. El sistema de temperatura que hace que los muffins suban alto como los de cafetería premium.'
}, {
  emoji: '🌾',
  title: 'Tomo 5 — El Mundo de las Galletitas y Cookies',
  subtitle: 'Pepas, Avena, Cookies con Craquelado y Masitas Finas para Regalo',
  desc: 'El producto de mayor durabilidad y stock acumulable. El sistema de venta por kilo que puede facturar $80.000 en un sábado.'
}, {
  emoji: '💰',
  title: 'Tomo 6 — El Manual del Emprendedor',
  subtitle: 'Costos, Precios, Packaging, WhatsApp Marketing y Plan de 30 Días',
  desc: 'El sistema que convierte tu cocina en un negocio real. La planilla de costos que incluye gas, tiempo y packaging. Los guiones de venta listos para copiar y pegar.'
}];
export function TomosSection() {
  return <section className="py-12 px-4 max-w-6xl mx-auto pt-[15px] pb-[15px]" data-id="element-314">
      <div className="text-center mb-16" data-id="element-315">
        <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-316">
          📚 6 TOMOS COMPLETOS
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-317">
        {tomos.map((tomo, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-white rounded-2xl p-8 shadow-warm border border-cream-dark hover:shadow-warm-lg transition-shadow pt-[5px] pb-[5px]" data-id="element-318">
            <div className="text-4xl mb-4" data-id="element-319">{tomo.emoji}</div>
            <h3 className="text-xl font-bold text-carbon mb-2" data-id="element-320">{tomo.title}</h3>
            <h4 className="text-sm font-medium text-brand-green mb-4" data-id="element-321">
              {tomo.subtitle}
            </h4>
            <p className="text-carbon-lighter text-sm leading-relaxed" data-id="element-322">
              {tomo.desc}
            </p>
          </motion.div>)}
      </div>
    </section>;
}